"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRpcUrls = exports.getConfiguration = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const provider_type_1 = require("@dcl/schemas/dist/dapps/provider-type");
const configuration = Object.freeze({
  storageKey: 'decentraland-connect-storage-key',
  [provider_type_1.ProviderType.INJECTED]: {},
  [provider_type_1.ProviderType.FORTMATIC]: {
    apiKeys: {
      [chain_id_1.ChainId.ETHEREUM_MAINNET]: 'pk_live_F8E24DF8DD5BCBC5',
      [chain_id_1.ChainId.ETHEREUM_ROPSTEN]: 'pk_test_5B728BEFE5C10911',
      [chain_id_1.ChainId.ETHEREUM_RINKEBY]: 'pk_test_5B728BEFE5C10911',
      [chain_id_1.ChainId.ETHEREUM_KOVAN]: 'pk_test_5B728BEFE5C10911',
      [chain_id_1.ChainId.ETHEREUM_GOERLI]: 'pk_test_5B728BEFE5C10911',
      [chain_id_1.ChainId.ETHEREUM_SEPOLIA]: 'pk_test_5B728BEFE5C10911'
    },
    urls: getRpcUrls(provider_type_1.ProviderType.FORTMATIC)
  },
  [provider_type_1.ProviderType.NETWORK]: {
    urls: getRpcUrls(provider_type_1.ProviderType.NETWORK)
  },
  [provider_type_1.ProviderType.WALLET_CONNECT]: {
    urls: getRpcUrls(provider_type_1.ProviderType.WALLET_CONNECT)
  },
  [provider_type_1.ProviderType.WALLET_LINK]: {
    appName: 'Decentraland',
    urls: getRpcUrls(provider_type_1.ProviderType.WALLET_LINK)
  },
  [provider_type_1.ProviderType.WALLET_CONNECT_V2]: {
    projectId: '61570c542c2d66c659492e5b24a41522',
    urls: getRpcUrls(provider_type_1.ProviderType.WALLET_CONNECT_V2),
    chains: {
      [chain_id_1.ChainId.ETHEREUM_MAINNET]: {
        chains: [chain_id_1.ChainId.ETHEREUM_MAINNET],
        optionalChains: [chain_id_1.ChainId.MATIC_MAINNET]
      },
      [chain_id_1.ChainId.ETHEREUM_GOERLI]: {
        chains: [chain_id_1.ChainId.ETHEREUM_GOERLI],
        optionalChains: [chain_id_1.ChainId.MATIC_MUMBAI]
      },
      [chain_id_1.ChainId.ETHEREUM_SEPOLIA]: {
        chains: [chain_id_1.ChainId.ETHEREUM_SEPOLIA],
        optionalChains: [chain_id_1.ChainId.MATIC_MUMBAI]
      }
    }
  }
});
function getConfiguration() {
  return configuration;
}
exports.getConfiguration = getConfiguration;
function getRpcUrls(providerType) {
  const rpcUrls = {
    [chain_id_1.ChainId.ETHEREUM_MAINNET]: 'https://rpc.decentraland.org/mainnet',
    [chain_id_1.ChainId.ETHEREUM_SEPOLIA]: 'https://rpc.decentraland.org/sepolia',
    [chain_id_1.ChainId.ETHEREUM_ROPSTEN]: 'https://rpc.decentraland.org/ropsten',
    [chain_id_1.ChainId.ETHEREUM_RINKEBY]: 'https://rpc.decentraland.org/rinkeby',
    [chain_id_1.ChainId.ETHEREUM_GOERLI]: 'https://rpc.decentraland.org/goerli',
    [chain_id_1.ChainId.ETHEREUM_KOVAN]: 'https://rpc.decentraland.org/kovan',
    [chain_id_1.ChainId.MATIC_MAINNET]: 'https://rpc.decentraland.org/polygon',
    [chain_id_1.ChainId.MATIC_MUMBAI]: 'https://rpc.decentraland.org/mumbai'
  };
  let project = '';
  switch (providerType) {
    case provider_type_1.ProviderType.WALLET_CONNECT:
      project = 'walletconnect';
      break;
    case provider_type_1.ProviderType.WALLET_LINK:
      project = 'walletlink';
      break;
    case provider_type_1.ProviderType.FORTMATIC:
      project = 'fortmatic';
      break;
    case provider_type_1.ProviderType.WALLET_CONNECT_V2:
      project = 'walletconnect-v2';
      break;
    default:
      break;
  }
  if (project) {
    for (const chainId in rpcUrls) {
      rpcUrls[chainId] += "?project=".concat(project);
    }
  }
  return rpcUrls;
}
exports.getRpcUrls = getRpcUrls;